class Particle {
  constructor(canvasWidth, canvasHeight) {
    this.x = Math.random() * canvasWidth;
    this.y = Math.random() * canvasHeight;
    this.size = Math.random() * 3 + 2;
    this.speedX = (Math.random() - 0.5) * 2;
    this.speedY = (Math.random() - 0.5) * 2;
  }

  update(canvasWidth, canvasHeight) {
    this.x += this.speedX;
    this.y += this.speedY;
    if (this.x < 0 || this.x > canvasWidth) this.speedX *= -1;
    if (this.y < 0 || this.y > canvasHeight) this.speedY *= -1;
  }

  draw(ctx) {
    ctx.fillStyle = '#4B0082';
    ctx.beginPath();
    ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
    ctx.fill();
  }
}

function initParticles(canvas) {
  console.log('Debug [Dev/Prod]: Starting particle initialization');

  if (!canvas || typeof canvas.getContext !== 'function') {
    console.error('Debug [Dev/Prod]: Canvas or context missing');
    return () => {};
  }

  const ctx = canvas.getContext('2d', { alpha: true, willReadFrequently: true });
  if (!ctx) {
    console.error('Debug [Dev/Prod]: Failed to get 2D context');
    return () => {};
  }

  console.log('Debug [Dev/Prod]: Canvas context acquired');

  const particlesArray = [];
  const numberOfParticles = 125;
  const maxDistance = 125;

  function resizeCanvas() {
    try {
      canvas.width = window.innerWidth || document.documentElement.clientWidth;
      canvas.height = window.innerHeight || document.documentElement.clientHeight;
      canvas.style.display = 'block';
      canvas.style.position = 'absolute';
      canvas.style.top = '0';
      canvas.style.left = '0';
      particlesArray.length = 0;
      for (let i = 0; i < numberOfParticles; i++) {
        particlesArray.push(new Particle(canvas.width, canvas.height));
      }
      console.log('Debug [Dev/Prod]: Canvas resized to', canvas.width, 'x', canvas.height);
    } catch (e) {
      console.error('Debug [Dev/Prod]: Resize error:', e);
    }
  }

  try {
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    for (let i = 0; i < numberOfParticles; i++) {
      particlesArray.push(new Particle(canvas.width, canvas.height));
    }

    let animationFrameId;
    function animate() {
      try {
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        particlesArray.forEach(particle => {
          particle.update(canvas.width, canvas.height);
          particle.draw(ctx);
        });

        for (let i = 0; i < particlesArray.length; i++) {
          for (let j = i + 1; j < particlesArray.length; j++) {
            const dx = particlesArray[i].x - particlesArray[j].x;
            const dy = particlesArray[i].y - particlesArray[j].y;
            const distance = Math.sqrt(dx * dx + dy * dy);

            if (distance < maxDistance) {
              const opacity = 1 - (distance / maxDistance);
              const gradient = ctx.createLinearGradient(
                particlesArray[i].x, particlesArray[i].y,
                particlesArray[j].x, particlesArray[j].y
              );
              gradient.addColorStop(0, '#4B0082');
              gradient.addColorStop(1, '#4682B4');

              ctx.beginPath();
              ctx.moveTo(particlesArray[i].x, particlesArray[i].y);
              ctx.lineTo(particlesArray[j].x, particlesArray[j].y);
              ctx.strokeStyle = gradient;
              ctx.lineWidth = 1;
              ctx.globalAlpha = opacity;
              ctx.stroke();
              ctx.globalAlpha = 1;
            }
          }
        }

        animationFrameId = requestAnimationFrame(animate);
      } catch (e) {
        console.error('Debug [Dev/Prod]: Animation error:', e);
        cancelAnimationFrame(animationFrameId);
      }
    }

    console.log('Debug [Dev/Prod]: Starting animation loop');
    animate();

    return () => {
      console.log('Debug [Dev/Prod]: Cleaning up particles');
      window.removeEventListener('resize', resizeCanvas);
      cancelAnimationFrame(animationFrameId);
    };
  } catch (e) {
    console.error('Debug [Dev/Prod]: Particle initialization failed:', e);
    return () => {};
  }
}

export default initParticles;